var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "edit-visibility" }, [
    _c(
      "a",
      {
        directives: [
          {
            name: "b-tooltip",
            rawName: "v-b-tooltip.top",
            value: _vm.eyeTooltipTitle,
            expression: "eyeTooltipTitle",
            modifiers: { top: true },
          },
        ],
        staticClass: "linked-section vis-mark clickable",
        on: { click: _vm.handleMultipleVisibility },
      },
      [_c("icon", { attrs: { name: _vm.isInvisible ? "eye-slash" : "eye" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }